import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap"

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  })

  const [errors, setErrors] = useState({})
  const [success, setSuccess] = useState(false)

  const handleChange = e => {
    const { id, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [id]: value,
    }))
  }

  const validate = () => {
    const newErrors = {}
    if (!formData.name.trim()) {
      newErrors.name = "Name is required"
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required"
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email format"
    }
    return newErrors
  }

  const handleSubmit = e => {
    e.preventDefault()
    const validationErrors = validate()
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      setSuccess(false)
    } else {
      setErrors({})
      setSuccess(true)
      console.log("Form Data Submitted: ", formData)
    }
  }

  return (
    <Container style={{ marginTop: "40px" }}>
      <Row>
        <Col>
          <h1 className="text-center mb-4">Contact Us</h1>
          <p className="text-center mb-5">
            Have any questions or feedback? Feel free to reach out to us. We
            would love to hear from you!
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-4">
          <Card>
            <CardBody>
              <h5 className="mb-3">Get in Touch</h5>
              <p>
                <strong>Email:</strong> support@example.com
              </p>
              <p>
                <strong>Phone:</strong> +123 456 7890
              </p>
              <p>
                <strong>Address:</strong> 123 Programming Lane, Tech City, Code
                World
              </p>
              <p>
                Our team is available from 9 AM to 6 PM, Monday to Friday. Feel
                free to drop by or send us a message anytime.
              </p>
            </CardBody>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card>
            <CardBody>
              <h5 className="mb-3">Send Us a Message</h5>
              {success && (
                <Alert color="success">
                  Thank you for contacting us! We will get back to you soon.
                </Alert>
              )}
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input
                    type="text"
                    id="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && (
                    <Alert color="danger" className="mt-2">
                      {errors.name}
                    </Alert>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    type="email"
                    id="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <Alert color="danger" className="mt-2">
                      {errors.email}
                    </Alert>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label for="message">Message</Label>
                  <Input
                    type="textarea"
                    id="message"
                    placeholder="Enter your message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </FormGroup>
                <Button color="primary" block>
                  Submit
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ContactUs
